(() => {
  if (window.dancingOaksProductCardImageCycle) return;
  window.dancingOaksProductCardImageCycle = true;

  const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  const initialDelay = 1500;
  const interval = 2200;

  const isEligible = () => hoverPointer.matches && !reducedMotion.matches;

  const createState = (card) => {
    const image = card.querySelector('.card__media img[data-cycle-src-2]');
    if (!image) return null;

    const frames = [{ src: image.src, srcset: image.srcset, ready: true }];
    [2, 3].forEach((number) => {
      const src = image.getAttribute(`data-cycle-src-${number}`);
      const srcset = image.getAttribute(`data-cycle-srcset-${number}`) || '';
      if (src) frames.push({ src, srcset, ready: false });
    });

    const state = { image, frames, index: 0, hovering: false, timer: null };
    states.set(card, state);
    return state;
  };

  const getState = (card) => states.get(card) || createState(card);

  const preload = (state) => {
    state.frames.slice(1).forEach((frame) => {
      if (frame.preloader) return;
      const preloader = new Image();
      frame.preloader = preloader;
      preloader.sizes = state.image.sizes;
      if (frame.srcset) preloader.srcset = frame.srcset;
      preloader.src = frame.src;
      const markReady = () => { frame.ready = true; };
      preloader.addEventListener('load', markReady, { once: true });
      if (preloader.complete && preloader.naturalWidth > 0) markReady();
    });
  };

  const showFrame = (state, index) => {
    const frame = state.frames[index];
    if (!frame?.ready) return false;
    state.image.srcset = frame.srcset;
    state.image.src = frame.src;
    state.index = index;
    return true;
  };

  const scheduleNext = (state, delay = interval) => {
    window.clearTimeout(state.timer);
    if (!state.hovering || !isEligible()) return;
    state.timer = window.setTimeout(() => {
      const nextIndex = (state.index + 1) % state.frames.length;
      if (showFrame(state, nextIndex)) scheduleNext(state);
      else scheduleNext(state, 100);
    }, delay);
  };

  const enter = (card) => {
    if (!isEligible()) return;
    const state = getState(card);
    if (!state || state.hovering) return;
    state.hovering = true;
    preload(state);
    scheduleNext(state, initialDelay);
  };

  const leave = (card) => {
    const state = states.get(card);
    if (!state) return;
    state.hovering = false;
    window.clearTimeout(state.timer);
    state.timer = null;
    showFrame(state, 0);
  };

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest('[data-card-image-cycle]');
    if (!card || card.contains(event.relatedTarget)) return;
    enter(card);
  });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest('[data-card-image-cycle]');
    if (!card || card.contains(event.relatedTarget)) return;
    leave(card);
  });
})();
